import { useRef, useEffect } from 'react'

// 커스텀 훅의 타입 정의
type UseTimeoutReturn = {
  setCustomTimeout: (callback: () => void, delay: number) => void
  clearCustomTimeout: () => void
}

function useTimeout(): UseTimeoutReturn {
  // 타임아웃 ID의 타입은 number | null
  const timeoutIdRef = useRef<number | null>(null)

  // 컴포넌트 언마운트 시 타이머 정리
  useEffect(() => {
    return () => {
      if (timeoutIdRef.current !== null) {
        clearTimeout(timeoutIdRef.current)
      }
    }
  }, [])

  // 타이머 설정 함수
  const setCustomTimeout = (callback: () => void, delay: number) => {
    // 기존 타이머가 있다면 정리
    if (timeoutIdRef.current !== null) {
      clearTimeout(timeoutIdRef.current)
    }

    // 새로운 타이머 설정
    timeoutIdRef.current = window.setTimeout(() => {
      callback()
    }, delay)
  }

  // 타이머를 취소하는 함수
  const clearCustomTimeout = () => {
    if (timeoutIdRef.current !== null) {
      clearTimeout(timeoutIdRef.current)
    }
  }

  return { setCustomTimeout, clearCustomTimeout }
}

export default useTimeout
